import React, { useState, useRef, useContext } from 'react'
import { Tag, Input } from 'antd'
import { TweenOneGroup } from 'rc-tween-one'
import { TicketContext } from '~/components/tickets/Show'
import { post } from '~/utils/api'

type TagType = {
  id: number
  name: string
}

const Tags = ({}) => {
  const context = useContext(TicketContext)
  const [tags, setTags] = useState<TagType[]>(context.tags)
  const [inputVisible, setInputVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<any>()

  const addTag = async (name: string) => {
    await post(`tickets/${context.ticket.id}/addTag`, {
      tag: name,
    })
  }

  const removeTag = async (name: string) => {
    await post(`tickets/${context.ticket.id}/removeTag`, {
      tag: name,
    })
  }

  const handleClose = removedTag => {
    const newTags = tags.filter(tag => tag !== removedTag)
    removeTag(removedTag.name)
    setTags(newTags)
  }

  const showInput = async () => {
    await setInputVisible(true)
    inputRef.current && inputRef.current.focus()
  }

  const handleInputChange = e => {
    const value = e.target.value
    const newValue = e.target.value[0] == '#' ? value : '#' + value
    setInputValue(newValue)
  }

  const handleInputConfirm = () => {
    if (inputValue && tags.map(i => i.name).indexOf(inputValue) === -1) {
      const newTag = {
        id: Math.random(),
        name: inputValue,
      }
      setTags([...tags, newTag])
      addTag(inputValue)
    }

    setInputVisible(false)
    setInputValue('')
  }

  const forMap = tag => {
    const tagElem = (
      <Tag
        closable
        onClose={e => {
          e.preventDefault()
          handleClose(tag)
        }}
      >
        {tag.name}
      </Tag>
    )
    return <span key={tag.id}>{tagElem}</span>
  }

  return (
    <div className="ticket-show-header__tags">
      {tags && (
        <TweenOneGroup
          className="ticket-show-tags__list"
          enter={{
            scale: 0.8,
            opacity: 0,
            type: 'from',
            duration: 100,
            onComplete: (e: any) => {
              e.target.style = ''
            },
          }}
          leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
          appear={false}
        >
          {tags.map(forMap)}
          <div className="ticket-show-tags__button">
            {inputVisible && (
              <Input
                ref={inputRef}
                type="text"
                size="small"
                className="tag-input"
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleInputConfirm}
                onPressEnter={handleInputConfirm}
              />
            )}
            {!inputVisible && (
              <Tag className="ticket-show-tags__add" onClick={showInput}>
                {intl.formatMessage({ id: 'ticket / tags / add' })}{' '}
                <span className="fa-solid fa-plus"></span>
              </Tag>
            )}
          </div>
        </TweenOneGroup>
      )}
    </div>
  )
}

export default Tags
